<template>
    <div class="mmid">
        <mu-carousel style="height: 6rem;" hide-controls hide-indicators>
            <mu-carousel-item >
                <img :src="carouselImg1" style="width: 100%">
            </mu-carousel-item>
            <mu-carousel-item>
                <img :src="carouselImg2" style="width: 100%">
            </mu-carousel-item>
        </mu-carousel>
        <div class="mmid-title">
            <h2 >深度开发虚拟电商行业解决方案</h2>
            <h3>突破传统发货瓶颈，对虚拟电商行业定制专属解决方案</h3>
        </div>
        <div class="mmid-demo">
            <ul>
                <li>
                    <img src="../../assets/phoneimg/fangan1.png" alt="">
                    <span class="demo-tittle">自动发卡解决方案</span>
                    <span class="demo-text">微涟网帮助店主实现24小时无人值守自动发送激活码、二维码，省心省时省力。帮助您获客拉新，促进交易达成，开启智能新零售。
                    </span>
                    <div>了解更多</div>
                </li>
                <li>
                    <img src="../../assets/phoneimg/fangan2.png" alt="">
                    <span class="demo-tittle">虚拟代充解决方案</span>
                    <span class="demo-text">微涟网提供两种代充方式即手动代充和API代充，商家可以根据自己的需求个性化配置，
快速帮助客户充值。</span>
                    <div>了解更多</div>
                </li>
                <li>
                    <img src="../../assets/phoneimg/fangan3.png" alt="">
                    <span class="demo-tittle">营销推广解决方案</span>
                    <span class="demo-text">代理改价、卡密拼团帮助您建立完成的销售体系，充分利用移动社交平台分享传播，快速提升商城交易量，为您打造超人气商城。</span>
                    <div>了解更多</div>
                </li>

            </ul>
        </div>
        <div class="aivip">
            <h2>智能会员管理</h2>
            <h3>让您更了解会员的消费习惯</h3>
            <img src="../../assets/phoneimg/vip-pic.jpg" alt="">
            <ul>
                <li>
                    <span><mu-icon class="aivip-logo" value="person" ></mu-icon>会员管理</span>
                    <p>轻松维护管理会员</p>
                </li>
                <li>
                    <span><mu-icon class="aivip-logo" value="show_chart"></mu-icon>会员营销</span>
                    <p>专属营销解决方案</p>
                </li>
                <li>
                    <span><mu-icon class="aivip-logo" value="local_offer"></mu-icon>会员标签</span>
                    <p>实现个性化营销</p>
                </li>
            </ul>
        </div>
        <div class="visible">
            <img src="../../assets/phoneimg/data_bg_img.jpg" alt="">
            <div>
                <h2>数据可视化展示</h2>
                <h3>一目了然有利于您科学统计分析运筹帷幄</h3>
                <div style="width: 100%;overflow: auto; margin-top: 1.5625rem;">
                    <ul class="items-slider">
                        <li>
                            <img src="../../assets/phoneimg/data-1.jpg" alt="">
                            <h4>交易数据</h4>
                            <span>快速掌握商城用户的交易周期，为您提供一手商城交易数据支持</span>
                        </li>
                        <li>
                            <img src="../../assets/phoneimg/data-2.jpg" alt="">
                            <h4>商品数据</h4>
                            <span>智能商品数据监控，自动统计商品数据，为您提供精准可靠、有效的销售数据</span>
                        </li>
                        <li>
                            <img src="../../assets/phoneimg/data-3.jpg" alt="">
                            <h4>会员数据</h4>
                            <span>帮助您快速掌握商场用户的交易周期，深入洞察分析，为您提供一手商城交易数据支持</span>
                        </li>
                    </ul>
                </div>
            </div>

        </div>
        <div class="onestop">
            <h2>一站式电商服务</h2>
            <h3>让您轻松进军新零售社交电商</h3>
            <ul>
                <li>
                    <img src="../../assets/phoneimg/one_step-1.png" alt="">
                    <h6>我们的优势</h6>
                    <span>支持个性化定制开发，近4年移动电商开发经验</span>
                </li>
                <li>
                    <img src="../../assets/phoneimg/one_step-2.png" alt="">
                    <h6>我们的服务</h6>
                    <span>以用户为中心，为您提供有针对性的电商解决方案</span>
                </li>
                <li>
                    <img src="../../assets/phoneimg/one_step-3.png" alt="">
                    <h6>我们的特色</h6>
                    <span>采用最新的研发技术，确保用户体验更流畅稳定</span>
                </li>
            </ul>
        </div>
        <div class="fooder">
            <div class="logo">
                <img src="../../assets/phoneimg/nav_logo.png" alt="">
            </div>
            <div class="body">
                <ul>
                    <li>国际顶级域名</li>
                    <li>出版物经营许可证</li>
                    <li>广播电视节目制作经营许可证</li>
                    <li>开户许可证</li>
                    <li>食品经营许可证</li>
                    <li>计算机软件著作权证书</li>
                    <li>网络文化经营许可证</li>
                    <li>营业执照</li>
                    <li>增值电信业务许可证</li>
                </ul>
            </div>
            <div class="last">
                <span>微涟科技有限公司版权所有</span>
                <span>©辽ICP备18009739号</span>
            </div>
        </div>
    </div>
</template>
<script>
    import carouselImg1 from '../../assets/b2.png';
    import carouselImg2 from '../../assets/b1.png';

    export default {
        name: 'mmid',
        data () {
            return {
                carouselImg1,
                carouselImg2
            }
        }
    }
</script>
<style scoped>

    .mmid{
        width: 100%;
        position: relative;
        top: 3rem;

    }
    .mmid-title>h2,.aivip>h2{
        margin: 2.5rem auto .4375rem;
        text-align: center;
        font-size: 1.0625rem;
        font-weight: 600;
        line-height: 1.0625rem;
        color: #5d6494;
    }
    .mmid-title>h3,.aivip>h3{
        width: 18.6875rem;
        text-align: center;
        font-size: .75rem;
        line-height: 1.3125rem;
        color: #9c9eae;
        font-weight: 400;
        margin: auto;
    }
    .mmid-demo{
        width: 100%;
        overflow: auto;
        margin: 1.40625rem 0 0;
    }
    .mmid-demo>ul{
        margin: 1.25rem auto 2.1875rem;
        width: 32.5rem;
        height: 12.5625rem;
        display: flex;
        padding-left: 1.25rem;
    }
    .mmid-demo>ul>li{
        height: 100%;
        width: 10rem;
        border-radius: .3125rem;
        background: #fff;
        flex-wrap: nowrap;
        margin: 0 .625rem 0 0;
        position: relative;
        box-shadow: 0 0.1875rem 1.25rem rgba(230,233,246,.6);
    }
    .mmid-demo>ul>li>img{
        width: 2.375rem;
        position: absolute;
        top: -1.0625rem;
        left: 0;
        right: 0;
        margin: auto;
    }
    .demo-tittle{
        display: block;
        position: absolute;
        left: 50%;
        overflow: hidden;
        padding: 0 .3125rem;
        white-space: nowrap;
        transform: translate(-50%);
        text-align: center;
        top: 3.28125rem;
        font-size: .8125rem;
        line-height: .9375rem;
        color: #303548;
        font-weight: 600;
    }
    .demo-tittle:before{
        content: "";
        position: absolute;
        z-index: -1;
        width: 100%;
        height: .5625rem;
        left: -.03125rem;
        bottom: -.03125rem;
        background: #ffdccc;
    }
    .demo-text{
        position: absolute;
        width: 100%;
        left: 0;
        right: 0;
        margin: auto;
        line-height: 1.15625rem;
        font-size: .75rem;
        color: #4d4a69;
        text-align: center;
        top: 4.8125rem;
        transform: scale(.9);
    }
    .mmid-demo>ul>li>div{
        position: absolute;
        width: 9.0625rem;
        height: 1.875rem;
        box-sizing: border-box;
        left: 0;
        right: 0;
        margin: auto;
        bottom: 0;
        border-top: 1px solid #eee;
        color: #f8572b;
        text-align: center;
        line-height: 1.875rem;
        font-size: .75rem;
        transform: scale(.85);
        text-decoration: none;
    }
    .aivip{
        background: #fff;
        overflow: hidden;
    }
    .aivip>img{
        width: 15.4375rem;
        display: block;
        margin: 1.5625rem auto 2.1875rem;
    }
    .aivip>ul{
        width: 21.9375rem;
        height: 2.25rem;
        display: flex;
        flex-wrap: nowrap;
        margin: 0 auto 2.25rem;
    }
    .aivip>ul>li{
        box-sizing: border-box;
        border-right: 1px solid #ddd;
        width: 33.4%;
        height: 2.25rem;
    }
    .aivip>ul>li>p{
        font-size: .75rem;
        line-height: .75rem;
        text-align: center;
        display: block;
        width: 100%;
        color: #828896;
    }
    .aivip-logo{
        width: .9375rem;
        height: .9375rem;
        margin-right: .4375rem;
        vertical-align: top;
    }
    .visible{
        position: relative;
        width: 100%;
        height: 27.96875rem;
    }
    .visible>img{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height:100%;
        z-index: -5;
    }
    .visible>div{
        width: 100%;
        position: relative;
        overflow: hidden;
    }
    .visible ul{
        width: 58.75rem;
        display: flex;
        flex-wrap: nowrap;
        padding: 0 0 0 1.25rem;
    }
    .visible li{
        width: 18.75rem;
        height: 18.9375rem;
        background: #fff;
        border-radius: .3125rem;
        margin: 0 .625rem 0 0;
        position: relative;
        float: left;
    }
    .visible h2{
        margin: 2.5rem auto .4375rem;
        text-align: center;
        font-size: 1.0625rem;
        font-weight: 600;
        line-height: 1.0625rem;
        color: #fff;
    }
    .visible h3{
        width: 18.6875rem;
        margin: auto;
        text-align: center;
        font-size: .75rem;
        line-height: 1.3125rem;
        color: #9c9eae;
        font-weight: 400;
    }
    .items-slider>li>img{
        position: absolute;
        width: 15.5rem;
        top: 2.5rem;
        left: 0;
        right: 0;
        margin: auto;
    }
    .items-slider>li>h4{
        position: absolute;
        width: 100%;
        text-align: center;
        top: 13.1875rem;
        font-size: .9375rem;
        line-height: .9375rem;
        color: #48546c;
    }
    .items-slider>li>span{
        position: absolute;
        width: 15.3125rem;
        left: 0;
        right: 0;
        margin: auto;
        top: 16rem;
        font-size: .75rem;
        line-height: 1.1875rem;
        color: #a5a8bb;
    }
    .onestop{
        height: 22rem;
        width: 100%;
        position: relative;
    }
    .onestop>h2{
        margin: 2.5rem auto .4375rem;
        text-align: center;
        font-size: 1.0625rem;
        font-weight: 600;
        line-height: 1.0625rem;
        color: #5d6494;
    }
    .onestop>h3{
        width: 18.6875rem;
        margin: auto;
        text-align: center;
        font-size: .75rem;
        line-height: 1.3125rem;
        color: #9c9eae;
        font-weight: 400;
    }
    .onestop>ul{
        width: 100%;
        margin-top: 2.0625rem;
    }
    .onestop>ul>li{
        width: 19.3125rem;
        margin: 0 auto 2.1875rem;
        position: relative;
        padding: 0 0 0 3.375rem;
        box-sizing: border-box;
        min-height: 2.6875rem;
    }
    .onestop>ul>li>img{
        position: absolute;
        width: 2.6875rem;
        height: 2.6875rem;
        top: 0;
        bottom: 0;
        margin: auto;
        left: 0;
    }
    .onestop>ul>li>h6{
        font-size: .9375rem;
        font-weight: 400;
        position: absolute;
        top: 0;
        left: 3.375rem;
        margin: 0;
    }
    .onestop>ul>li>span{
        position: absolute;
        bottom: 0;
        left: 3.375rem;
        font-size: .75rem;
        font-weight: 400;
        color: #7e8a96;
        line-height: .9375rem;
        white-space: nowrap;
    }
    .fooder{
        width: 100%;
        overflow: hidden;
        background: #1c1c24;
        position: relative;
    }
    .logo{
        width: 20.9375rem;
        margin: auto;
        height: 4.96875rem;
        position: relative;
        margin-left: 2rem;
    }
    .logo>img{
        width: 14.25rem;
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
        height: auto;
    }
    .body{
        width: 100%;
        box-sizing: border-box;
        margin: auto;
    }
    .body>ul{
        width: 100%;
        margin-bottom: 1.5rem;
        overflow: hidden;

    }
    .body li{
        margin: 0 1.1875rem 0 0;
        font-size: .75rem;
        color: #888;
        line-height: .75rem;
        width: calc(33% - 1rem);
        float: left;
        margin:  .5rem;
    }
    .last{
        width: 20.9375rem;
        margin: auto;
        height: 4.125rem;
        box-sizing: border-box;
        border-top: 1px solid hsla(0,0%,100%,.1);
        padding: 1.125rem 0 0 0;
        margin-bottom: 3rem;
    }
    .last>span{
        display: block;
        font-size: .625rem;
        color: #3d404d;
        line-height: 1rem;
        text-align: center;
    }
    ul{
        list-style: none;
        padding: 0;
    }




</style>


// WEBPACK FOOTER //
// src/components/phone/mmid.vue